import { render, staticRenderFns } from "./GanttChart.vue?vue&type=template&id=3f78a1b2&scoped=true&"
import script from "./GanttChart.vue?vue&type=script&lang=js&"
export * from "./GanttChart.vue?vue&type=script&lang=js&"
import style0 from "./GanttChart.vue?vue&type=style&index=0&id=3f78a1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f78a1b2",
  null
  
)

export default component.exports